import { interpolate } from '@format/interpolate';
import { truncatePrice } from '../products';
import {
  ADDON_PRODUCT_TYPES,
  ADDON_PRODUCT_TYPES_LIST,
  DENTAL_CHEWS_SKUS,
} from './constants';

export const findAddonProduct = (subAddon, addonProductList) =>
  addonProductList?.find(
    addonProduct => addonProduct.data.sku === subAddon.sku,
  );

export const isMultipackSku = sku => /(\d+)PK$/.test(sku ?? '');

export const getQuantityType = (type, sku) => {
  // a fresh multipack is 1 sellable unit (ie Holiday Feast is 2 packs),
  // but it should have a quantity type of item
  if (isMultipackSku(sku)) return 'item';

  if (type === ADDON_PRODUCT_TYPES.treats) {
    if (sku?.includes('FR')) {
      return 'pint';
    }
    return 'bag';
  } else if (type === ADDON_PRODUCT_TYPES.supplements) {
    return 'jar';
  }
  return 'item';
};
export const addonsQuantityFormatter = (quantity, type, sku) => {
  const quantityType = getQuantityType(type, sku);

  if (!quantityType) return `${quantity}`;

  return quantity > 1
    ? `${quantity} ${quantityType}s`
    : `${quantity} ${quantityType}`;
};

export const getMergedAddonModals = (addonModals, treats, supplements) =>
  addonModals.map(modal => {
    const product = [...supplements, ...treats].find(
      addon => (addon?.legacySku ?? addon?.sku) === modal.sku,
    );

    const saveText =
      parseFloat(product?.discounted_price) < parseFloat(product?.price)
        ? `(Save ${Math.floor(
            ((parseFloat(product.price) -
              parseFloat(product.discounted_price)) /
              parseFloat(product.price)) *
              100,
          )}%)` // math to get percent off full price
        : '';

    return interpolate(modal, {
      addonPrice: truncatePrice(product?.price),
      addonDiscount: truncatePrice(product?.discounted_price),
      addonSavePercentage: saveText,
    });
  });

export const getRecommendedDentalChew = treats =>
  treats?.find(
    addon =>
      DENTAL_CHEWS_SKUS.includes(addon.sku) && !!addon.product_recommended,
  );

export const getAvailableAddons = (allAddonsinCMS, treats) => {
  const recommendedDentalChew = getRecommendedDentalChew(treats);
  return allAddonsinCMS
    .filter(item => ADDON_PRODUCT_TYPES_LIST.includes(item.productType))
    .filter(
      addon =>
        addon?.sku === recommendedDentalChew?.sku ||
        !DENTAL_CHEWS_SKUS.includes(addon?.sku),
    );
};

export const compileAddonText = (productName, productType, sku, quantity) => {
  const containerTypes = {
    SP: 'jar',
    TR: 'bag',
    DC: 'bag',
  };

  const isFrozen = !!sku?.includes('FR');

  const container = !isFrozen ? containerTypes[productType] : 'pint';
  return `${productName} (${quantity} ${container}${quantity > 1 ? 's' : ''})`;
};
